import { pathService } from "../../../jwt/_services/xeeker/pathService";
import { setLoading } from "../generalActions/mainActions";
import {setForm, setItem} from "../generalActions/formActions";

export const saveMap = data => ( dispatch ) => {
    dispatch(setLoading(true))

    pathService.saveMap(data)
        .then( result => {
            if(!result)
                return

            dispatch( setForm(false, true, true) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const calculatePath = data => ( dispatch ) => {
    dispatch(setLoading(true))

    pathService.calculatePath(data)
        .then( result => {
            if(!result)
                return

            dispatch( setForm(false, true, true) )
        })
        .finally(() => dispatch(setLoading(false)))
}
